import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useEffect, useState } from 'react';
import { auth } from '../../firebase/firebase';
import { argosApiEntryPoint } from '../../GlobalConfig';
import { Button, LinearProgress, Link } from '@mui/material';

interface MostFrequentCollaboratorsTableProps {
    institutionId: string
    institutionName: string
    onAuthorSelected: (openAlexaAuthorId: string, authorDisplayName: string, institution: string | undefined, institutionName: string | undefined,  collaborationMode: boolean) => void
}

interface MostFrequentCollaborator {
    authorProfileId: string,
    authorName: string,
    retractionsForInstitution: number
    totalRetractions: number
}

export default function MostFrequentCollaboratorsTable({ institutionId, institutionName, onAuthorSelected }: MostFrequentCollaboratorsTableProps) {

    const [isLoading, setIsLoading] = useState(true)
    const [mostFrequentCollaborators, setMostFrequentCollaborators] = useState<MostFrequentCollaborator[]>([]);


    useEffect(() => {

        setIsLoading(true)

        async function fetchData() {
            let authToken = await auth.currentUser?.getIdToken(true)
            let apiPath = "most-frequent-collaborators-on-retractions"

            fetch(argosApiEntryPoint + '/stats/institutional-summary/' + apiPath + '?institutionId=' + institutionId + "&institutionName=" + institutionName
                , {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json;charset=UTF-8',
                        'Authorization': 'Bearer ' + authToken
                    }
                })
                .then((response) => response.json())
                .then((data: MostFrequentCollaborator[]) => {
                    setMostFrequentCollaborators(data)
                    setIsLoading(false)
                }
                );
        }
        fetchData()
    }, [institutionId]);

    return (
        <>
            {isLoading && <LinearProgress />}
            {!isLoading &&
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Author Profile</TableCell>
                                <TableCell>Author Name</TableCell>
                                <TableCell align="right">Retractions <br /> with this institution</TableCell>
                                <TableCell align="right">Retracted Articles</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {mostFrequentCollaborators.map((row) => (
                                <TableRow
                                    key={row.authorProfileId}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell>
                                        <Link href={row.authorProfileId} target="_blank">
                                            <img src="/argos/static/images/logos/openalex_logo.png" width='30px' />
                                        </Link>
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {row.authorName}
                                    </TableCell>
                                    <TableCell align="right">
                                        <Button onClick={() => onAuthorSelected(row.authorProfileId, row.authorName, institutionId, institutionName, true)}>
                                            {row.retractionsForInstitution}
                                        </Button>
                                    </TableCell>
                                    <TableCell align="right">
                                        <Button onClick={() => onAuthorSelected(row.authorProfileId, row.authorName, undefined, undefined, false)}>
                                            {row.totalRetractions}
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>}
        </>
    );
}